<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `annexes/profTestInter/${inputs.id}`
            : `annexes/profTestInter/`
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{
                ["OICC"].includes(this.activity)
                  ? "DESCRIPCIÓN DEL ENSAYO/CALIBRACIÓN"
                  : ["OEAP"].includes(this.activity)
                  ? "DESCRIPCIÓN DEL PROGRAMA"
                  : ""
              }}</label>
              <app-input
                type="textarea"
                v-model="inputs.description"
                placeholder="Ingrese la descripción"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Nº PARTICIPANTES ACREDITADOS</label>
              <app-input
                type="number"
                v-model="inputs.participants_no"
                placeholder="Ingrese el numero de participantes"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="['OICC'].includes(this.activity)">
          <div class="col-12">
            <div class="form-group">
              <label>ORGANIZADOR</label>
              <app-input
                type="text"
                v-model="inputs.organizer"
                placeholder="Ingrese el organizador"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>FECHAS (PERIODICIDAD)</label>
              <app-input
                type="text"
                v-model="inputs.periodicity_date"
                placeholder="Ingrese la fecha"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="['OICC'].includes(this.activity)">
          <div class="col-12">
            <div class="form-group">
              <label>RESULTADOS Z-SCORE O FECHA TENTATIVA</label>
              <app-input
                type="text"
                v-model="inputs.result"
                placeholder="Ingrese los resultados"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ProfTestInterModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      modalTitle: "Añadir Intercomparacione o Ensayo",
      disabledSubmit: false,
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = "Editar Intercomparacione o Ensayo";
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = {
        ...this.inputs,
        accreditation_application_id: this.$store.state.accreditation.id,
      };
      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
